var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteFooterDivider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200px",
    height: "259px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TPO-Footer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TPO-Footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1200,
    height: 85
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#EDE6F1",
    points: "0 14.4808636 233.04884 0 896.907477 54.2014316 1200 14.4808636 1200 80 0 79.6204809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#460074",
    points: "0 27.9894551 903.53958 68.5929491 1200 15 1200 259 0 259"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFooterDivider);
export default __webpack_public_path__ + "static/media/white_footer_divider.b3ec38e332a3cc6780572b36d68fd89b.svg";
export { ForwardRef as ReactComponent };